module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner_stores/banner_stores_sapporo-c35c393314c5474d43f6ede036f0fdea.jpg";